import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDuzOpRENtoYB2pwi1OaNOWziuKlr1sAI0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
})
